import { motion } from "framer-motion";
import { scrollToForm } from "@/App";

const MODELS = [
  {
    key: "180l",
    name: "Rinnai 180L",
    capacity: "180L",
    people: "Up to 3 people",
    made: null,
  },
  {
    key: "265l",
    name: "Rinnai 265L",
    capacity: "265L",
    people: "Up to 4 people",
    made: null,
  },
  {
    key: "ar300l",
    name: "Rinnai AR 300L",
    capacity: "300L",
    people: "Up to 5 people",
    made: "Australian designed & made",
  },
  {
    key: "ar340l",
    name: "Rinnai AR 340L",
    capacity: "340L",
    people: "Up to 6 people",
    made: "Australian designed & made",
  },
];

const RinnaiRange = () => {
  return (
    <section
      data-testid="rinnai-range-section"
      className="bg-white py-20 md:py-28"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gdark mb-4 flex items-center justify-center gap-2">
            <span className="inline-block w-8 h-px bg-gdark" />
            The Rinnai range
            <span className="inline-block w-8 h-px bg-gdark" />
          </p>
          <h2 className="font-serif font-bold text-navy tracking-tight text-4xl md:text-5xl leading-tight">
            The right size for your household
          </h2>
        </motion.div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {MODELS.map((m, i) => (
            <motion.div
              key={m.key}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`rinnai-card-${m.key}`}
              className="bg-white border border-navy/10 rounded-[20px] p-6 flex flex-col items-center hover:shadow-xl transition-shadow duration-300"
              style={{ boxShadow: "0 20px 45px rgba(1,27,71,0.10)" }}
            >
              <img
                src="/images/rinnai.webp"
                alt={`${m.name} heat pump hot water unit`}
                data-testid={`rinnai-card-${m.key}-photo`}
                className="h-32 w-auto object-contain"
                loading="lazy"
              />
              <h3 className="mt-4 font-serif font-bold text-navy text-2xl tracking-tight">
                {m.name}
              </h3>
              <p className="mt-1 text-base text-navy-muted">{m.people}</p>
              {m.made && (
                <span
                  data-testid={`rinnai-card-${m.key}-made-badge`}
                  className="mt-3 inline-block bg-glight/25 text-navy text-xs font-bold uppercase tracking-wider rounded-full px-3 py-1.5"
                >
                  {m.made}
                </span>
              )}
              <button
                onClick={scrollToForm}
                data-testid={`rinnai-card-${m.key}-link`}
                className="mt-4 text-sm font-bold text-gdark underline underline-offset-4 hover:text-navy transition-colors duration-200"
              >
                Get my price →
              </button>
            </motion.div>
          ))}
        </div>

        <p
          data-testid="rinnai-range-warranty"
          className="mt-10 text-lg font-semibold text-navy"
        >
          All Rinnai heat pumps come with a 7-year cylinder warranty*
        </p>
        <p
          data-testid="rinnai-range-warranty-note"
          className="mt-2 text-xs text-navy-muted"
        >
          *Warranty terms apply. See Rinnai warranty for details.
        </p>
      </div>
    </section>
  );
};

export default RinnaiRange;
